import { renderInDocument } from '@spotahome/soyuz/client';

import RefereePage from './main';

renderInDocument(RefereePage);
